export default {
  defaultObject () {
    return {
      id: undefined,
      name: '',
      color: '',
      parentId: null,
      isExternal: false,
      holeColor: '',
      points: [],
      holes: []
    }
  },

  cupDefaultObject () {
    return {
      latitude: null,
      longitude: null
    }
  }
}